import { createSelector } from 'reselect';

export const getCredentialsForGroup = createSelector(
  [
    (state, groupId) => state.credentialsGroups?.credentialsById?.[groupId] || [],
    (state) => state.entities?.credentials || {},
  ],
  (credentialIds, credentialEntities) =>
    credentialIds.map((id) => credentialEntities[id]).filter(Boolean),
);

export const getCredentialsListing = createSelector(
  [(state) => state.credentialsGroups.listing, (state) => state.entities?.credentials || {}],
  (credentialIds, credentialEntities) =>
    credentialIds.map((id) => credentialEntities[id]).filter(Boolean),
);
